import { createListenerMiddleware } from "@reduxjs/toolkit";
import { getConstructorFieldGroups } from "../lib/getConstructorFieldGroups.js";
import { getConstructorFields } from "../lib/getConstructorFields.js";
import { actions } from "../model/slice.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  predicate(action) {
    return actions.mergeLayout.match(action.type) || actions.set.match(action.type) || actions.update.match(action.type) && !!action.payload && !!action.payload.layout;
  },
  effect: (_, listenerApi) => {
    const state = listenerApi.getState();
    const { layout = {} } = state.config;
    const constructorFieldsMap = /* @__PURE__ */ new Map();
    Object.entries(layout).forEach(([page, constructorGrid]) => {
      const groups = getConstructorFieldGroups(constructorGrid);
      const value = new Map(
        groups.map((group) => [
          group,
          {
            fields: getConstructorFields(constructorGrid, state.config, group, "fields"),
            referenceFields: getConstructorFields(constructorGrid, state.config, group, "referenceFields")
          }
        ])
      );
      constructorFieldsMap.set(page, value);
    });
    listenerApi.dispatch(
      actions.update({
        constructorFieldsMap
      })
    );
  }
});
const { middleware } = listenerMiddleware;
export {
  middleware
};
